import React, {useEffect} from "react";
import IMG from "../../../constants/image";
import ImageBasic from "../Image/ImageBasic";

const Loading = ({isCustom}) => {

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        }
    }, [])


    if (isCustom) return (
        <div
            className='w-full flex justify-center items-center text-center text-black text-sm'>
            <div
                className='flex flex-col rounded-lg justify-center p-2 items-center w-[200px] bg-white'>
                <ImageBasic className='w-16 md:w-20' src={IMG.gif.loading}/>
                <div>Vui lòng đợi trong giây lát</div>
            </div>
        </div>
    )

    return (
        <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 animate-fadeIn'>
            <div className='relative bg-white p-4 md:p-6 rounded-md shadow-lg'>
                <div
                    className='w-[170px] md:w-[200px] h-[80px] md:h-[90px] flex flex-col justify-center items-center text-center text-black text-sm'>
                    <ImageBasic className='w-16 md:w-20' src={IMG.gif.loading}/>
                    <div>Vui lòng đợi trong giây lát</div>
                </div>
            </div>
        </div>
    )
}

export default Loading;
